import { render, staticRenderFns } from "./layout-admin.vue?vue&type=template&id=670b3b2c"
import script from "./layout-admin.vue?vue&type=script&lang=ts"
export * from "./layout-admin.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports